/**
 * RegExp to check to see if a string matches the long date format
 */
const longDate = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

/**
 * RegExp to check to see if a string matches the short date format
 */
const shortDate = /^\d{1,2}\/\d{1,2}\/\d{4}/;

/**
 * Does a given string 'look' like a known/supported date format
 *
 * @param val the string to check
 * @returns boolean
 */
export const looksLikeDate = (val: string): boolean => longDate.test(val ?? '') || shortDate.test(val ?? '');
